import styled, { css } from "styled-components";

export const StyledDropdown = styled.div`
  position: relative;
  display: inline-flex;
`;

export const Toggle = styled.button`
  outline: none;
  border: none;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: ${(props) => props.color};
  transition: transform 0.35s;

  &:focus {
    border: none;
    outline: none;
  }

  &:after {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    z-index: 500;
    border-top: 0.35rem solid;
    border-right: 0.35rem solid transparent;
    border-bottom: 0;
    border-left: 0.35rem solid transparent;
    margin-left: 0.25rem;
    transition: transform 0.35s;

    ${(props) =>
      props.isOpen &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;
  min-width: 120px;
  text-align: left;
  border-radius: 8px;
  border: 1px solid #e1e4e8;
  padding: 4px 0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
  background: #fff;
  white-space: nowrap;
`;

export const ListItem = styled.li`
  a {
    display: block;
    text-decoration: none;
    color: #212529;
    cursor: pointer;
    padding: 8px 16px;
    transition: background 0.35s;

    &:hover {
      background: #ebebeb;
    }
  }
`;

export const SubListItem = styled.li`
  position: relative;

  > span {
    display: flex;
    align-items: center;
    color: #212529;
    cursor: pointer;
    padding: 8px 16px;
    transition: background 0.35s;
    user-select: none;

    &:hover {
      background: #ebebeb;
    }

    .submenu-chevron {
      margin-left: auto;
      padding-left: 12px;
      font-size: 10px;
      opacity: 0.55;
    }
  }
`;

export const SubList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 4px 0;
  position: absolute;
  top: 0;
  right: 100%;
  min-width: 180px;
  border-radius: 8px;
  border: 1px solid #e1e4e8;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
  background: #fff;
  white-space: nowrap;
  z-index: 11;
`;
